import React, { Component } from 'react';
import _ from 'lodash';

import {
  addPlatform,
  deletePlatform
} from 'util/pouchActions';

import PouchInput from 'components/PouchInput';
import AddIcon from 'icons/AddIcon';
import DeleteIcon from 'icons/DeleteIcon';

class Platforms extends Component {

  deletePlatform = (platform) => {
    if(_.size(this.props.meet.platforms) <= 1) {
      alert("You must have one platform");
    } else {
      const message = `Are you sure you want to delete platform ${platform.name}?`;
      if(window.confirm(message)) {
        deletePlatform(platform, this.props.meet._id);
      }
    }
  }

  render() {
    const { meet } = this.props;
    return (
      <div className="platforms">
        <table>
          <thead>
            <tr>
              <th>
                Platform name
              </th>
              <th style={{width: '22%'}}>
                ID
              </th>
              <th style={{width: '6%'}}>
                <button onClick={() => addPlatform(meet)}>
                  <AddIcon />
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            {
              _.map(_.sortBy(meet.platforms, 'name'), (platform) => {
                return (
                  <tr key={platform._id}>
                    <td>
                      <PouchInput
                        style={{width: '100%'}}
                        type='text'
                        meetId={meet._id}
                        documentId={platform._id}
                        name='name'
                        value={_.get(platform, 'name')}
                      />
                    </td>
                    <td>
                      {platform._id}
                    </td>
                    <td>
                      <button onClick={() => this.deletePlatform(platform)}>
                        <DeleteIcon />
                      </button>
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    );
  }
}

export default Platforms;
